import React, { useState, useEffect } from "react";
import { CardDownload } from "./wrapper";
import { API, Auth, Storage } from "aws-amplify";
import LoadingPage from "../../Loading/LoadingPage";

function HistoryFile() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchHistoryFile();
  }, []);

  const fetchHistoryFile = async () => {
    try {
      setLoading(true);
      const { items = [] } = await API.get(
        "MoneyHubAdmin",
        "/buro/historyFile"
      );

      const newItems = await Promise.all(
        items.map(async (item) => {
          return {
            ...item,
            path_url: await Storage.get(item.path),
          };
        })
      );

      const sortItems = newItems?.sort((a, b) => {
        return `${a.buroDate}T:${a.buroTime}` < `${b.buroDate}T:${b.buroTime}`
          ? 1
          : -1;
      });
      setFiles(sortItems);
    } catch (error) {
      console.log("load history file error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="grid grid-cols-4 gap-6">
          {files.map((file, index) => {
            return (
              <CardDownload
                key={index}
                path={file.path}
                path_url={file.path_url}
                buroTime={file.buroTime}
                count={file.count}
              />
            );
          })}
        </div>
      )}
      <div></div>
    </div>
  );
}

export default HistoryFile;
